import {
    CREATEENTITYMAPPING_SUCCESS,
    CREATEENTITYMAPPING_FAILED,
    RESET_CREATEENTITYMAPPING,
    LOADING_CREATEENTITYMAPPING,
    NETWORK_ERROR_CREATEENTITYMAPPING,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: "",
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_CREATEENTITYMAPPING:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: "",
            };
        case CREATEENTITYMAPPING_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case CREATEENTITYMAPPING_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case NETWORK_ERROR_CREATEENTITYMAPPING:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: "",
            };
        case RESET_CREATEENTITYMAPPING:
            return (state = initialState);
        default:
            return state;
    }
};
